import CloseIcon from "@mui/icons-material/Close";
import { Box, Button, Card, Divider, Modal } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";

const PaymentModal = ({ modalOpen, setModalOpen, selectedPaymentId }) => {
  const admin = JSON.parse(localStorage.getItem("admin"));
  const [payementDetails, setPaymentDetails] = useState({});
  const [sellerBankDetails, setSellerBankDetails] = useState({});

  useEffect(() => {
    (async () => {
      if (!admin.token) return;
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_URL}v1.0.0/admin/settlements/settlements.php?type=payments_details&order_record_id=${selectedPaymentId}`,
        {
          headers: {
            Authorization: `Bearer ${admin.token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      console.log(
        "data?.response?.payment_list[0]",
        data?.response?.payment_list[0]
      );

      setPaymentDetails(data?.response?.payment_list[0]);
      setSellerBankDetails(data?.response?.payment_list[0]?.seller_bank[0]);
    })();
  }, [selectedPaymentId]);

  return (
    <Modal
      open={modalOpen}
      onClose={() => setModalOpen(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          border: "0px solid white",
          width: "60%",
          height: 800,
          bgcolor: "background.paper",
          border: "2px solid #fff",
          borderRadius: "20px",
        }}
      >
        <div
          style={{
            width: "100%",
            height: "80px",
            padding: "10px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div
            style={{
              width: "5%",
              height: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Button onClick={() => setModalOpen(false)}>
              <CloseIcon style={{ fontSize: "2rem", color: "#A36E29" }} />
            </Button>
          </div>
          <div
            style={{
              width: "50%",
              height: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "flex-start",
              marginRight: "auto",
              
              
            }}
          >
            <div
              style={{
                fontWeight: 800,
                fontSize: "1.2rem",
                color: "#333333",
                fontFamily: '"Work Sans", sans-serif',
              }}
            >
              <b>Order : {payementDetails?.order_id}</b>
            </div>
            <div
              style={{
                fontWeight: 800,
                color: "gray",
                fontFamily: '"Work Sans", sans-serif',
              }}
            >
              {new Date(payementDetails?.updated_at).toLocaleDateString(
                "en-GB"
              )}
            </div>
          </div>
          <div
            style={{
              width: "20%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-around",
              alignItems: "flex-start",
              marginRight: "auto",
              position: "relative",
              right: "100px",
            }}
          >
            <div
              style={{
                fontWeight: 800,
                color: "gray",
                fontFamily: '"Work Sans", sans-serif',
                marginBottom: "10px",
              }}
            >
              SETTLEMENT ID
            </div>
            <div
              style={{
                color: "#333333",
                fontFamily: '"Work Sans", sans-serif',
                marginTop: "10px",
                
              }}
            >
              <b>{payementDetails?.settlement_public_id}</b>
            </div>
          </div>
          <div
            style={{
              width: "20%",
              height: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-around",
              alignItems: "flex-start",
              marginLeft: "auto",
              marginRight: "80px",
            }}
          >
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  fontWeight: 800,
                  color: "gray",
                  fontFamily: '"Work Sans", sans-serif',
                }}
              >
                STATUS:
              </div>
              <div
                style={{
                  backgroundColor:
                    payementDetails?.settlement_status === "NOT_SETTLED"
                      ? "#F99B1CDF"
                      : "#87c914",
                  marginLeft: "10px",
                  padding: "7px",
                  paddingLeft: "15px",
                  paddingRight: "15px",
                  color: "white",
                  borderRadius: "5px",
                  fontFamily: '"Work Sans", sans-serif',
                }}
              >
                <b>{payementDetails?.settlement_status}</b>
              </div>
            </div>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                position: "relative",
                left: "-20px"
              }}
            >
              <div
                style={{
                  fontWeight: 800,
                  color: "gray",
                  fontFamily: '"Work Sans", sans-serif',
                  marginRight: "10px"
                }}
              >
                PAYMENT:
              </div>
              <div
                style={{
                  fontSize: "1.2rem",
                  color: "#333333",
                  fontFamily: '"Work Sans", sans-serif',
                }}
              >
                <b>Rs. {payementDetails?.total_amount}</b>
              </div>
            </div>
          </div>
        </div>
        <Divider />
        {payementDetails?.settlement_status === "NOT_SETTLED" ? (
          <div></div>
        ) : (
          <>
            <div
              style={{
                width: "100%",

                padding: "50px",
                paddingTop: "25px",
                paddingBottom: "0px",
              }}
            >
              <div
                style={{
                  fontWeight: 800,
                  fontSize: "1.5rem",
                  color: "#333333",
                  fontFamily: '"Work Sans", sans-serif',
                }}
              >
                Settlement Details
              </div>
            </div>

            <div
              style={{
                width: "100%",
                minHeight: "150px",
                height: "max-content",

                display: "flex",
                padding: "50px",
                paddingTop: "0px",
                paddingBottom: "0px",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  width: "48%",
                  height: "150px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  justifyContent: "space-evenly",
                }}
              >
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <div
                    style={{
                      width: "200px",
                      fontWeight: 800,
                      color: "gray",
                      fontSize: "1.1rem",
                      fontFamily: '"Work Sans", sans-serif',
                    }}
                  >
                    Type
                  </div>
                  <div
                    style={{
                      width: "75%",
                      color: "rgba(0,0,0,0.8)",
                      fontWeight: 500,
                      fontSize: "1.1rem",
                      fontFamily: '"Work Sans", sans-serif',
                    }}
                  >
                    Normal Settlement
                  </div>
                </div>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <div
                    style={{
                      width: "200px",
                      fontWeight: 800,
                      color: "gray",
                      fontSize: "1.1rem",
                      fontFamily: '"Work Sans", sans-serif',
                    }}
                  >
                    Setted On
                  </div>
                  <div
                    style={{
                      width: "75%",
                      fontSize: "1.1rem",
                      color: "rgba(0,0,0,0.8)",
                      fontWeight: 500,
                      fontFamily: '"Work Sans", sans-serif',
                    }}
                  >
                    {new Date(
                      payementDetails?.settlement_date
                    ).toLocaleDateString("en-GB")}
                  </div>
                </div>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <div
                    style={{
                      width: "200px",
                      fontWeight: 800,
                      color: "gray",
                      fontSize: "1.1rem",
                      fontFamily: '"Work Sans", sans-serif',
                    }}
                  >
                    Account
                  </div>
                  <div
                    style={{
                      width: "75%",
                      fontSize: "1.1rem",
                      color: "rgba(0,0,0,0.8)",
                      fontWeight: 500,
                      fontFamily: '"Work Sans", sans-serif',
                    }}
                  >
                    {sellerBankDetails?.ac_number?.replace(/.(?=.{4})/g, "*")}
                  </div>
                </div>
              </div>

              <div
                style={{
                  width: "48%",
                  height: "150px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  justifyContent: "space-evenly",
                }}
              >
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <div
                    style={{
                      width: "200px",
                      fontWeight: 800,
                      color: "gray",
                      fontSize: "1.1rem",
                      fontFamily: '"Work Sans", sans-serif',
                    }}
                  >
                    UTR No.
                  </div>
                  <div
                    style={{
                      width: "75%",
                      fontSize: "1.1rem",
                      color: "rgba(0,0,0,0.8)",
                      fontWeight: 500,
                      fontFamily: '"Work Sans", sans-serif',
                    }}
                  >
                    {payementDetails?.utr_number}
                  </div>
                </div>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <div
                    style={{
                      width: "200px",
                      fontWeight: 800,
                      color: "gray",
                      fontSize: "1.1rem",
                      fontFamily: '"Work Sans", sans-serif',
                    }}
                  >
                    Bank Name
                  </div>
                  <div
                    style={{
                      width: "75%",
                      fontSize: "1.1rem",
                      color: "rgba(0,0,0,0.8)",
                      fontWeight: 500,
                      fontFamily: '"Work Sans", sans-serif',
                    }}
                  >
                    {sellerBankDetails?.ac_bank_name}
                  </div>
                </div>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <div
                    style={{
                      width: "200px",
                      fontWeight: 800,
                      color: "gray",
                      fontSize: "1.1rem",
                      fontFamily: '"Work Sans", sans-serif',
                    }}
                  >
                    IFSC Code
                  </div>
                  <div
                    style={{
                      width: "75%",
                      color: "rgba(0,0,0,0.8)",
                      fontWeight: 500,
                      fontSize: "1.1rem",
                      fontFamily: '"Work Sans", sans-serif',
                    }}
                  >
                    {sellerBankDetails?.ac_ifsc}
                  </div>
                </div>
              </div>
            </div>
            <Divider />
          </>
        )}
        <div
          style={{
            width: "100%",
            padding: "50px",
            paddingTop: "25px",
            paddingBottom: "25px",
          }}
        >
          <div
            style={{
              fontWeight: 800,
              fontSize: "1.5rem",
              color: "#333333",
              fontFamily: '"Work Sans", sans-serif',
            }}
          >
            Customer Details
          </div>
        </div>

        <div
          style={{
            width: "100%",
            display: "flex",
            padding: "50px",
            paddingTop: "0px",
            paddingBottom: "30px",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div
            style={{
              width: "48%",
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "8px",
              }}
            >
              <div
                style={{
                  width: "200px",
                  fontWeight: 800,
                  color: "gray",
                  fontSize: "1.1rem",
                  fontFamily: '"Work Sans", sans-serif',
                }}
              >
                Name
              </div>
              <div
                style={{
                  width: "75%",
                  fontSize: "1.1rem",
                  color: "rgba(0,0,0,0.8)",
                  fontWeight: 500,
                  fontFamily: '"Work Sans", sans-serif',
                }}
              >
                {payementDetails?.user_details?.name}
              </div>
            </div>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                marginTop: "8px",
              }}
            >
              <div
                style={{
                  width: "200px",
                  fontWeight: 800,
                  color: "gray",
                  fontSize: "1.1rem",
                  fontFamily: '"Work Sans", sans-serif',
                }}
              >
                Email Id
              </div>
              <div
                style={{
                  width: "75%",
                  fontFamily: '"Work Sans", sans-serif',
                  fontSize: "1.1rem",
                  color: "rgba(0,0,0,0.8)",
                  fontWeight: 500,
                }}
              >
                {payementDetails?.user_details?.email}
              </div>
            </div>
          </div>

          <div
            style={{
              width: "48%",
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "8px",
              }}
            >
              <div
                style={{
                  width: "200px",
                  fontWeight: 800,
                  color: "gray",
                  fontSize: "1.1rem",
                  fontFamily: '"Work Sans", sans-serif',
                }}
              >
                Phone
              </div>
              <div
                style={{
                  width: "75%",
                  fontFamily: '"Work Sans", sans-serif',
                  fontSize: "1.1rem",
                  color: "rgba(0,0,0,0.8)",
                  fontWeight: 500,
                }}
              >
                +{payementDetails?.user_details?.mobile}
              </div>
            </div>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                marginTop: "8px",
              }}
            >
              <div
                style={{
                  width: "200px",
                  fontWeight: 800,
                  color: "gray",
                  fontSize: "1.1rem",
                  fontFamily: '"Work Sans", sans-serif',
                }}
              >
                User Since
              </div>
              <div
                style={{
                  width: "75%",
                  color: "rgba(0,0,0,0.8)",
                  fontWeight: 500,
                  fontFamily: '"Work Sans", sans-serif',
                  fontSize: "1.1rem",
                }}
              >
                {new Date(
                  payementDetails?.user_details?.created_at
                ).toLocaleDateString("en-GB")}
              </div>
            </div>
          </div>
        </div>
        <Divider />
        <div
          style={{
            width: "100%",
            padding: "50px",
            paddingTop: "25px",
            paddingBottom: "0px",
          }}
        >
          <div
            style={{
              fontWeight: 800,
              fontSize: "1.5rem",
              color: "#333333",
              fontFamily: '"Work Sans", sans-serif',
            }}
          >
            Payment Details
          </div>
        </div>
        <Card
          elevation={3}
          style={{
            width: "90%",
            height: "max-content",
            display: "flex",
            justifyContent: "space-between",
            margin: "auto",
            borderRadius: "10px",
            padding: "40px",
            marginTop: "20px",
            marginBottom: "50px",
            paddingBottom: "20px",
          }}
        >
          <Box
            style={{
              width: "47%",
              height: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div
              style={{
                width: "100%",
                paddingTop: "20px",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <div
                style={{
                  fontWeight: 600,
                  color: "gray",
                  width: "250px",
                  fontSize: "1.2rem",
                  fontFamily: '"Work Sans", sans-serif',
                }}
              >
                Payment Received :{" "}
              </div>
              <div
                style={{
                  fontWeight: 600,
                  color: "green",
                  fontSize: "1.2rem",
                  fontFamily: '"Work Sans", sans-serif',
                }}
              >
                Rs. {parseFloat(payementDetails?.total_amount).toFixed(2)}
              </div>
            </div>
            <div
              style={{
                width: "100%",
                paddingTop: "20px",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <div
                style={{
                  fontWeight: 600,
                  color: "gray",
                  width: "250px",
                  fontSize: "1.2rem",
                  fontFamily: '"Work Sans", sans-serif',
                }}
              >
                Platform Charge :{" "}
              </div>
              <div
                style={{
                  fontWeight: 600,
                  color: "red",
                  fontSize: "1.2rem",
                  fontFamily: '"Work Sans", sans-serif',
                }}
              >
                Rs. {parseFloat(payementDetails?.commission_perc).toFixed(2)}
              </div>
            </div>
            <div
              style={{
                width: "100%",
                paddingTop: "20px",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <div
                style={{
                  fontWeight: 600,
                  color: "gray",
                  width: "250px",
                  fontSize: "1.2rem",
                  fontFamily: '"Work Sans", sans-serif',
                }}
              >
                PG Charge :
              </div>
              <div
                style={{
                  fontWeight: 600,
                  color: "red",
                  fontSize: "1.2rem",
                  fontFamily: '"Work Sans", sans-serif',
                }}
              >
                Rs. {parseFloat(payementDetails?.commission_gst).toFixed(2)}
              </div>
            </div>
            <div
              style={{
                width: "100%",
                paddingTop: "20px",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <div
                style={{
                  fontWeight: 600,
                  color: "gray",
                  width: "250px",
                  fontSize: "1.2rem",
                  fontFamily: '"Work Sans", sans-serif',
                }}
              >
                Final Amount :
              </div>
              <div
                style={{
                  fontWeight: 600,
                  color: "green",
                  fontSize: "1.2rem",
                  fontFamily: '"Work Sans", sans-serif',
                }}
              >
                Rs. {parseFloat(payementDetails?.settlement_amount).toFixed(2)}
              </div>
            </div>
          </Box>
          <Box
            style={{
              width: "47%",
              height: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div
              style={{
                width: "100%",
                paddingTop: "20px",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <div
                style={{
                  fontWeight: 600,
                  color: "gray",
                  width: "250px",
                  fontSize: "1.2rem",
                  fontFamily: '"Work Sans", sans-serif',
                }}
              >
                TDS :
              </div>
              <div
                style={{
                  fontWeight: 600,
                  color: "red",
                  fontSize: "1.2rem",
                  fontFamily: '"Work Sans", sans-serif',
                }}
              >
                Rs. {parseFloat(payementDetails?.tds_perc).toFixed(2)}
              </div>
            </div>
            <div
              style={{
                width: "100%",
                paddingTop: "20px",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <div
                style={{
                  fontWeight: 600,
                  color: "gray",
                  width: "250px",
                  fontSize: "1.2rem",
                  fontFamily: '"Work Sans", sans-serif',
                }}
              >
                TCS :
              </div>
              <div
                style={{
                  fontWeight: 600,
                  color: "red",
                  fontSize: "1.2rem",
                  fontFamily: '"Work Sans", sans-serif',
                }}
              >
                Rs. {parseFloat(payementDetails?.tcs_perc).toFixed(2)}
              </div>
            </div>
          </Box>
        </Card>
      </Box>
    </Modal>
  );
};

export default PaymentModal;
